/*
 *
 * LanguageProvider actions
 *
 */

import { CHANGE_LOCALE } from './actionTypes';

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}
